<template>
  <div class="GlobalTable">
    <GlobalTable ref="GlobalTable" v-loading="loading" :columns="tableColumns" :data="this.seachDataList"
      :currentPage="page.pageNum" :total="page.total" @handleCurrentChange="handleCurrentChange">
      <el-table-column label="账单流水号" slot="uniqNo" align="center">
        <template slot-scope="{ row }">
          <span v-if="row.serType == '62'" style="color: red;">{{ row.uniqNo || "--" }}</span>
          <span v-else>{{ row.uniqNo || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="原始订单号" slot="orderNo" align="center">
        <template slot-scope="{ row }">
          <div style="color: #0981ff;cursor: pointer;" v-if="row.orderChannel == 'recycle'" @click="toOrderDetails(row)">
            <span style="border-bottom: 1px solid #0981ff">{{ row.orderNo }}</span></div>
          <span v-else>{{ row.orderNo || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="回收商名称" slot="merchantName" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.merchantName || "--" }}</span>
          <div v-if="row.merchantNice">
            <el-tag type="warning" effect="dark" size="mini">靓机回收商</el-tag>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="账单类型" slot="opt" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.opt == '01' ? '入账' : row.opt == '02' ? '出账' : '挂账' }}</span>
        </template>
      </el-table-column>
      <el-table-column label="交易门店商家" slot="companyName" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.companyName || "--" }}</span>
        </template>
      </el-table-column>
      <el-table-column label="交易门店" slot="storeName" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.storeName || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="金额" slot="amount" align="center">
        <template slot-scope="{ row }">
          <span :style="row.opt == '01' ? 'color:green' : 'color:red'" v-if="row.opt != '03'">{{ row.amount>=0 && row.opt ==
            '01' ? `+${row.amount}` : `-${row.amount}` }}</span>
          <span :style="row.serType == '23' ? 'color:green' : 'color:red'" v-else>{{ row.amount && row.serType ==
            '23' ? `+${row.amount}` : `-${row.amount}` }}</span>
        </template>
      </el-table-column>
      <el-table-column label="当前余额" slot="nowBalance" align="center">
        <template slot-scope="{ row }">
          <span>{{ row.nowBalance || "--" }}</span>
        </template>
      </el-table-column>

      <el-table-column label="账单备注" width="130rpx" slot="remark" align="center">
        <template slot-scope="{ row }">
          <el-tooltip class="item" effect="dark" :content="row.remark" placement="top">
            <div class="Remarks">
              {{ row.remark || "--" }}
            </div>
          </el-tooltip>
        </template>
      </el-table-column>
    </GlobalTable>
  </div>
</template>

<script>
import _api from "@/utils/request";
export default {
  name: "Table",
  props: {
    accountType: {
      require: true,
      type: String
    },
  },
  data() {
    return {
      loading: false,
      seachDataList: [],
      page: {
        pageNum: 1,
        pageSize: 10
      },
      pageNum: 1,
      tableColumns: [
        { slotName: "uniqNo" },
        { slotName: "orderNo" },
        { slotName: "merchantName" },
        // { label: "回收商名称", prop: "merchantName" },
        { label: "账单时间", prop: "createTime" },
        { slotName: "opt" },
        { label: "子类型", prop: "title" },
        { slotName: "companyName" },
        { slotName: "storeName" },
        { slotName: "amount" },
        { slotName: "nowBalance" },
        { slotName: "remark" }
      ]
    };
  },
  created() {
    this.handleCurrentChange();
  },
  computed: {
    SeachParams() {
      return this.$store.state.tagsView.SeachParams
    },
  },
  watch: {
    SeachParams(newVal) {
      console.log(newVal)
      this.handleCurrentChange()
    },
    accountType(newVal) {
      console.log(newVal)
      if (newVal == 'merchant') {
        this.tableColumns = [
          { label: "账单流水号", prop: "uniqNo" },
          { slotName: "orderNo" },
          { slotName: "merchantName" },
          // { label: "回收商名称", prop: "merchantName" },
          { label: "账单时间", prop: "createTime" },
          { slotName: "opt" },
          { label: "子类型", prop: "title" },
          { slotName: "companyName" },
          { slotName: "storeName" },
          { label: "金额", prop: "amount" },
          { slotName: "remark" }
        ]
      } else {
        this.tableColumns = [
          { label: "账单流水号", prop: "uniqNo" },
          { slotName: "orderNo" },
          { label: "门店商名称", prop: "companyName" },
          { label: "账单时间", prop: "createTime" },
          { slotName: "opt" },
          { label: "子类型", prop: "title" },
          { label: "交易回收商家", prop: "merchantName" },
          { slotName: "storeName" },
          { label: "金额", prop: "amount" },
          { slotName: "remark" }
        ]
      }
      this.handleCurrentChange()
    }
  },
  methods: {
    // 表格切换页面
    handleCurrentChange(val) {
      if (val) {
        this.pageNum = val
        this.page.pageNum = val;
      } else {
        this.page.pageNum = 1;
      }
      const baseRequest = {
        // accountType: this.accountType,
        accountType: "company",
        merchantId: this.SeachParams.merchantId,
        companyId: this.SeachParams.companyId,
        storeId: this.SeachParams.storeId,
        uniqNo: this.SeachParams.uniqNo,
        orderNo: this.SeachParams.orderNo,
        opt: this.SeachParams.opt,
        serType: this.SeachParams.serType,
        startTime: this.SeachParams.startTime,
        endTime: this.SeachParams.endTime,
        pageNum: this.page.pageNum,
        pageSize: this.page.pageSize,
      };
      this.loading = true
      _api.getAccountPayList(baseRequest).then(res => {
        console.log(res)
        if (res.code === 1 && res.data && res.data.records) {
          this.seachDataList = res.data.records;
          this.page.total = res.data.total;
          this.page.pageNum = res.data.current;
          this.loading = false
          this.$emit('billNumber', { companyUniqCount: res.data.companyUniqCount, merchantUniqCount: res.data.merchantUniqCount })
        }
      }).finally(() => { 
        this.loading = false
        if (typeof this.SeachParams.disuseLoding === 'function') {
          this.SeachParams.disuseLoding();
        }
      })
    },
    toOrderDetails(row) {
      this.$router.push({ path: "/RecallOrder/Details", query: { type: 'edit', id: row.orderNo } })
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalTable {

  // 备注说明
  .Remarks {
    width: 100%;
    height: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2; //控制行数
    overflow: hidden;
  }

  .operation-btn {
    /deep/.el-button {
      margin-left: 0;
    }
  }
}
</style>
